import { useEffect, useState } from "react";
import AccountMail from "~/assets/icons/AccountMail";
import AccountName from "~/assets/icons/AccountName";
import AccountPhone from "~/assets/icons/AccountPhone";
import BlackCircleLoading from "~/assets/icons/BlackCircleLoading";
import { callSendEmail, emailValidation } from "~/lib/utils";
import { Modal } from "~/rs-components/global/Modal.client";
import { productsForm } from "~/types";
import { askAQuestionForm } from "../../../setup/settings/__product";
import { TemplateAskAQuestion } from "../../../setup/components/TemplateAskAQuestion.client";


export default function AskQuestionForm() {

    const [form, setForm] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
        url: '',

    });

    const [errorsForm, setErrorsForm] = useState<productsForm>({
        name: null,
        email: null,
        phone: null,
        message: null,
        url: null,
    })

    const [loading, setLoading] = useState<boolean>(false);

    const [hasSubmitError, setHasSubmitError] = useState(false);
    const [hasSubmitSuccess, setHasSubmitSuccess] = useState(false);

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setLoading(true);
        checkEmail(event);
        const validate = validateFieldsRequired();
        const emailError = emailValidation(event.currentTarget.email);
        if (emailError) {
            setErrorsForm(old => ({ ...old, email: emailError }))
            setLoading(false);
            return;
        }
        if (validate) await sendMail();
        else{setLoading(false);}
    }

    const onChange = (event) => {
        setForm(old => ({ ...old, [event.target.id]: event.target.value }))
    }

    const emptyErrorsForm = () => {
        setErrorsForm({
            name: null,
            email: null,
            phone: null,
            message: null,
            url: null,
        })
    }

    const emptyInputForm = () => {
        setForm({
            name: '',
            email: '',
            phone: '',
            message: '',
            url: '',
        })
    }

    const sendMail = async () => {
        form.url = window.location.href;
        const body = {
            "from": { "email": `${form.email}`, "name": `${form.name}` },
            "recipient": { "email": `${askAQuestionForm.email}`, "name": "" },
            "subject": "Ask a question",
            "message": TemplateAskAQuestion(form),
        }
        const response = await callSendEmail(body, true);
        if (response.error) {
            setLoading(false)
            emptyErrorsForm()
            setHasSubmitError(false)
        } else {
            setLoading(false)
            setHasSubmitSuccess(true)
            emptyInputForm()
        }
    }

    useEffect(() => {
        if (hasSubmitError) {
            setTimeout(() => {
                setHasSubmitError(false);
            }, 5000);
        }
    }, [hasSubmitSuccess]);

    useEffect(() => {
        if (hasSubmitSuccess) {
            setTimeout(() => {
                setHasSubmitSuccess(false);
            }, 5000);
        }
    }, [hasSubmitSuccess]);

    const validateFieldsRequired = () => {
        if (form.name === '') {
            setErrorsForm(old => ({ ...old, name: "This field is required" }))
            return false;
        }
        if (form.email === '') {
            setErrorsForm(old => ({ ...old, email: "This field is required" }))
            return false;
        }
        if (form.phone === '') {
            setErrorsForm(old => ({ ...old, phone: "This field is required" }))
            return false;
        }
        if (form.message === '') {
            setErrorsForm(old => ({ ...old, message: "This field is required" }))
            return false;
        }
        return true;
    }
    const checkEmail = (event: React.FormEvent<HTMLFormElement>) => {
        if (!event.currentTarget.email.validity.valid) {
            setErrorsForm(old => ({ ...old, email: 'Please enter a valid email' }))
        }
    }

    const [show, setShow] = useState(false);
    return (
        <>
            {show &&
                <Modal close={() => setShow(false)}>
                    <>
                        <div className="requestCustomizationForm">
                            <div className="requestCustomizationForm__header">
                                <h1>Ask a question:</h1>

                            </div>
                            <form onSubmit={handleSubmit}>

                                <div className="mt-3 containerInput"> <AccountName />
                                    <input
                                        className={`userLogin__input emailInput ${errorsForm.name ? ' border-red-500' : 'border-gray-500'
                                            }`}
                                        id="name"
                                        name="name"
                                        type="text"
                                        autoComplete="given-name"
                                        required
                                        placeholder="Full name"
                                        aria-label="Full name"
                                        value={form.name}
                                        onChange={onChange}
                                    />
                                    <p
                                        className={`text-red-500 text-xs ${!errorsForm.name ? 'invisible' : ''}`}
                                    >
                                        {errorsForm.name} &nbsp;
                                    </p>
                                </div>

                                <div className="mt-3 containerInput"> <AccountMail />
                                    <input
                                        className={`userLogin__input emailInput ${errorsForm.email ? ' border-red-500' : 'border-gray-500'
                                            }`}
                                        id="email"
                                        name="email"
                                        type="email"
                                        autoComplete="email"
                                        required
                                        placeholder="Email address"
                                        aria-label="Email address"
                                        value={form.email}
                                        onChange={onChange}
                                    />
                                    <p
                                        className={`text-red-500 text-xs ${!errorsForm.email ? 'invisible' : ''}`}
                                    >
                                        {errorsForm.email} &nbsp;
                                    </p>
                                </div>

                                <div className="mt-3 containerInput"> <AccountPhone />
                                    <input
                                        className={`userLogin__input emailInput ${errorsForm.phone ? ' border-red-500' : 'border-gray-500'
                                            }`}
                                        id="phone"
                                        name="phone"
                                        type="tel"
                                        autoComplete="tel"
                                        required
                                        placeholder="Phone"
                                        aria-label="Phone"
                                        value={form.phone}
                                        onChange={onChange}
                                    />
                                    <p
                                        className={`text-red-500 text-xs ${!errorsForm.phone ? 'invisible' : ''}`}
                                    >
                                        {errorsForm.phone} &nbsp;
                                    </p>
                                </div>
                                <p className="requestCustomizationForm__contact-options">Your message:</p>
                                <textarea className={`mt-3 containerInput textareaQuestion userLogin__input emailInput ${errorsForm.phone ? ' border-red-500' : 'border-gray-500'
                                    }`} value={form.message} onChange={onChange} required placeholder="Message"
                                    id="message" name="message" autoComplete='message' ></textarea>


                                <br></br>
                                <button className="black-button submitBtn">
                                    {!loading ? 'Submit' :
                                        <div className="text-center">LOADING  <BlackCircleLoading /></div>
                                    }
                                </button>
                            </form>
                            {hasSubmitError && (
                                <div className="flex items-center justify-center mb-6">
                                    <p className="m-4 text-s text-red-500 errorSend">
                                        Sorry, the request could not be sent. Please try again.
                                    </p>
                                </div>
                            )}
                            {hasSubmitSuccess && (
                                <div className="flex items-center justify-center mb-6">
                                    <p className="m-4 text-s text-green-500 confirmSend">
                                        Your request was sent successfully.
                                    </p>
                                </div>
                            )}
                        </div>
                    </>
                </Modal>}
            <div className="requestPrice">
                <div className="formContainer">
                    <span onClick={() => setShow(true)} className="black-button btn-customization">Ask us a question</span>
                </div>
            </div>
        </>
    )
}